export default __webpack_public_path__ + "assets/wind-beaufort-7.a2101772.svg";